import type { DataWithMeta } from './type-helpers';

const makeError = <T, S extends string>(message: S): DataWithMeta<T> =>
    ({
        data: undefined as any,
        _meta: { total: 0, success: false, message },
    }) as const;

export { makeError };
